import React, { useMemo } from 'react';
import styles from './text.module.css';
import useInterpolation from '#/hooks/use-interpolation.js';

export default function Text({ desc, children }) {
  const interpolate = useInterpolation();
  let { content, className } = desc;

  const [html, text] = useMemo(() => {
    if (typeof content === 'object') {
      if (content['720']) {
        // TODO: apply matched to screen variant,
        //  or even better: at the recalculating stage drop all,
        //  except the only one and apply real size base on application rem.
        content = content['720'];
      }
    }
    return [interpolate(content), interpolate(children)];
  }, [content, children, interpolate]);

  if (html) {
    return (
      <div
        id={desc.id}
        dangerouslySetInnerHTML={{ __html: html }}
        className={`${styles.textWidget} ${className ?? ''}`}
      />
    );
  }

  return (
    <div id={desc.id} className={`${styles.textWidget} ${className ?? ''}`}>
      {text}
    </div>
  );
}
